module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMA/wD/AP83WBt9AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAJUlEQVR42mP8//8/AymAiYFEQHsNjAwMQ94Pw0EDC4lJaTD6AQAfFwYbs4C3pQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/red_mpa.png
// module id = fbyd
// module chunks = 0